import { render, staticRenderFns } from "./Chip.vue?vue&type=template&id=d31050ac&scoped=true&"
import script from "./Chip.vue?vue&type=script&lang=js&"
export * from "./Chip.vue?vue&type=script&lang=js&"
import style0 from "./Chip.vue?vue&type=style&index=0&id=d31050ac&prod&lang=css&"
import style1 from "./Chip.vue?vue&type=style&index=1&id=d31050ac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d31050ac",
  null
  
)

export default component.exports